import { formatCurrency, SoftwarePlansRecurringTypesEnum } from '@thinknet-gmbh/platform-common';

export const expireDateFormatter = (exp_year: number, exp_month: number) => {
  if (exp_month > 0 && exp_month < 10) {
    return `0${exp_month}/${exp_year.toString().slice(2, 4)}`;
  }
  return `${exp_month}/${exp_year}`;
};

export const formatPaymentPrice = (price: number, currency: string, recurring: string) => {
  return `${formatCurrency(price, currency)} per ${
    recurring === SoftwarePlansRecurringTypesEnum.MONTHLY ? 'month' : 'year'
  }`;
};
